module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAARCAYAAAACCvahAAAABHNCSVQICAgIfAhkiAAAAPBJREFUOI2tkSFOxGAQhd9rKjAI7IZLgOIMCCSerNugIPM3gYSE4Dq9AA7JEao2SILhAAiCwWHWQco8zDZZ0aUty1PzkvkyXzI0s0MANyT3MSCS7tz9BABykrcAniLivA/MsuwCwE7bcwC7ku6rqnrog81sCmC77UwpaYhuh36dL4czSc9DQZIzAJN8Wd7cvVe7jZkdAZhkY3VXk6+WoiiOI2K2ZvcTwKm7v3TCEbEg2akv6atpmo+1l929BlD/p/Y3ycuyLB9/hbu0JQXJ997LY7U3elUmaSFp7y8wzeya5NVYUNKcAJBSOoiIrZHw6w9q3mxckBXMpQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/new icon/workName.png
// module id = 1072
// module chunks = 1